import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';

import { Comment } from '../../types/comment';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '@ml/shared/components';
import { User } from '@ml/core/types/classes/user.class';
import { UserRole } from '@ml/core/types/enums';

@Component({
  selector: 'ml-comment',
  template: `
    <div class="full-width" fxLayout="row" fxLayoutAlign="space-between">
      <mat-list>
        <div class="comment">
          <div
            fxLayout="row"
            fxLayoutAlign="space-between center"
            class="full-width mat-body-1"
            matLine
          >
            <span
              ><strong
                >{{ comment.user.firstName }}&nbsp;{{
                  comment.user.lastName
                }}</strong
              ></span
            >
          </div>
          <div
            matLine
            fxLayout="row"
            fxLayoutAlign="start center"
            class="mat-caption"
          >
            <span>{{ comment.created | date: 'short' }}</span>
          </div>
          <div class="comment-text mat-body-2" matLine>
            {{ comment?.text }}
          </div>
        </div>
      </mat-list>
      <button
        mat-icon-button
        *ngIf="
          currentUser?.id === comment.user.id ||
          currentUser?.role === roles.ADMIN
        "
        (click)="onDelete()"
      >
        <mat-icon svgIcon="delete"></mat-icon>
      </button>
    </div>
    <ng-content></ng-content>
  `,
  styleUrls: ['./comment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommentComponent implements OnInit {
  roles = UserRole;

  @Input() comment: Comment;
  @Input() currentUser: User;
  @Output() delete: EventEmitter<Comment> = new EventEmitter();

  constructor(private dialog: MatDialog) {}

  ngOnInit() {}

  onDelete() {
    this.dialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'are you sure you want to delete this comment'
        }
      })
      .afterClosed()
      .subscribe((confirm: boolean) => {
        if (confirm) {
          this.delete.emit(this.comment);
        }
      });
  }
}
